const courses_pt = require('./courses.json')
export default courses_pt